import DealershipsTable from './DealershipsTable';

export default DealershipsTable;
